/**
 * 사업계획서 양식 카탈로그 — 호환 레이어
 * 실제 저장·resolve 는 system/formRegistryStore (CM-DESIGN-005)
 * SSOT: D:\295\erp\BD\design\13_사업계획서_OSS_에디터.md §2.2
 *       D:\295\erp\CM\design\05_양식레지스트리_매칭.md
 */
import { DOC_TYPE } from 'system/formDocTypes';
import {
  listFormsByDocType,
  getForm as registryGetForm,
  upsertForm as registryUpsertForm,
  getTenantFormBindings as registryGetBindings,
  setTenantActiveForm as registrySetActive,
  bindFormToTenant as registryBind,
  resolveForm,
  formationLinkedFields,
  dbLinkedFields,
  ensureFormRegistry,
} from 'system/formRegistryStore';
import {
  BIZ_FORM_CATALOG_KEY,
  BIZ_FORM_TENANT_BIND_PREFIX,
  FORM_ID_GOYANG_CULTURE_V1,
  createFormId,
  GOYANG_CULTURE_V1_FIELDS,
  buildGoyangCultureV1FormMeta,
} from 'budget/bizFormCatalogSeed';

export {
  BIZ_FORM_CATALOG_KEY,
  BIZ_FORM_TENANT_BIND_PREFIX,
  FORM_ID_GOYANG_CULTURE_V1,
  createFormId,
  GOYANG_CULTURE_V1_FIELDS,
  buildGoyangCultureV1FormMeta,
  formationLinkedFields,
  dbLinkedFields,
};

export function ensureFormCatalog() {
  return ensureFormRegistry();
}

export function listForms() {
  return listFormsByDocType(DOC_TYPE.BIZ_PLAN);
}

export function getForm(formId) {
  const f = registryGetForm(formId);
  if (f && f.docType && f.docType !== DOC_TYPE.BIZ_PLAN) return null;
  return f;
}

export function upsertForm(form) {
  return registryUpsertForm({ ...form, docType: form.docType || DOC_TYPE.BIZ_PLAN });
}

export function getTenantFormBindings(tenantCode) {
  const slot = registryGetBindings(tenantCode, DOC_TYPE.BIZ_PLAN);
  return {
    tenantCode,
    bindings: slot?.bindings || [],
    updatedAt: new Date().toISOString(),
  };
}

export function setTenantActiveForm(tenantCode, formId) {
  return registrySetActive(tenantCode, DOC_TYPE.BIZ_PLAN, formId);
}

export function bindFormToTenant(tenantCode, formId, opts) {
  return registryBind(tenantCode, DOC_TYPE.BIZ_PLAN, formId, opts);
}

/** @param {string} tenantCode @param {object} [ctx] deptCode·projectCode·userId 등 */
export function resolveActiveFormForTenant(tenantCode, ctx = {}) {
  return resolveForm(DOC_TYPE.BIZ_PLAN, { tenantCode, ...ctx });
}
